import { render, staticRenderFns } from "./ConfirmChangeEmail.vue?vue&type=template&id=be1b04a2&scoped=true&"
import script from "./ConfirmChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmChangeEmail.vue?vue&type=style&index=0&id=be1b04a2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b04a2",
  null
  
)

export default component.exports